export default "__VITE_ASSET__DnRmesGn__"